export default __webpack_public_path__ + "static/media/mansik (1).4defa70c.jpg";